import { Box, Container, Grid, IconButton, Paper, Stack, Typography } from "@mui/material";
import ScreenBanner from "../../../../../components/ScreenBanner";
import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import DialogRegistrarRecebimento from "../DialogRegistrarRecebimento";
import DialogListarTodas from "../../../../../components/DialogListarTodas";
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../../../../components/ListaAcoesRapidas";
import PreFiltros, { initialFiltersRecebimentoBaixas } from "./PreFiltros";
import AddIcon from '@mui/icons-material/Add';
import DialogIncluirRecebimento from "../DialogIncluirRecebimento";
import useSetParamsURL from "../../../../../lib/useSetParamsURL";
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import { TableDataGridV2 } from "../../../../../components/TableDataGridV2";
import React from "react";
import moment from "moment";
import PermissionGuard, { usePermission } from "../../../../../components/PermissionGuard";
import { colunasRecebimentoBaixas } from "./dataGridConfig";
import { TFilters } from "../../../../../components/TableDataGridV2/types";
import { processUrlFilters } from "../../../../../components/TableDataGridV2/helpers";
import BtnImprimirRelatorio from "./BtnImprimirRelatorio";

export default function ListarRecebimentosBaixas() {

    const [openFullScreen, setOpenFullScreen] = useState(false);
    const [filters, setFilters] = useState<TFilters>(initialFiltersRecebimentoBaixas);
    const [openRegistrarDialog, setOpenRegistrarDialog] = useState(false);
    const [openIncluirDialog, setOpenIncluirDialog] = useState(false);
    const [preFilter, setPreFilter] = useState(true);
    const { searchParams, setMultipleParamsUrl } = useSetParamsURL()

    const containerRef = useRef<HTMLDivElement>(null);

    const handleChangePreFilters = (value: TPreFilters) => {
        const filteredValues: Record<string, any> = {};

        Object.entries(value).forEach(([key, value]) => {
            if (value === null || value === "" || (Array.isArray(value) && value.length === 0) || value === "null" || value === 'undefined' || value === undefined) {
                filteredValues[key] = ""
                return
            }
            if (moment.isMoment(value)) {
                filteredValues[key] = value.format("YYYY-MM-DD");
            } else {
                filteredValues[key] = value;
            }
        });
        setFilters({ ...filteredValues, page: 1, limit: 25 });
        setMultipleParamsUrl(filteredValues);
        if (containerRef.current) {
            containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    const handleClosePreFilter = useCallback(() => {
        setPreFilter(false)
    }, [])

    useEffect(() => {
        if (searchParams.size > 0) {
            const urlFilters = processUrlFilters({}, searchParams);
            setFilters(urlFilters);
            setPreFilter(false)
        }
    }, [searchParams])

    const listaAcoesRapidas: TItemAcaoRapida[] = [
        {
            label: "Cadastrar título a receber",
            icon: <AddIcon color="primary" />,
            action: () => { setOpenIncluirDialog(true) },
            havePermission: usePermission("financeiro.incluir-titulo-receber")
        },
        {
            label: "Registrar recebimento",
            icon: <DownloadDoneIcon color="primary" />,
            action: () => setOpenRegistrarDialog(true),
            havePermission: usePermission("financeiro.registrar-recebimento")
        },
    ]

    const RenderListagem = useMemo(() => {
        const TableComponent = () => (
            <>
                {
                    preFilter &&
                    <Box
                        minHeight={370}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <PreFiltros
                            filtros={filters}
                            onSubmitFilters={(values) => {
                                handleChangePreFilters(values)
                                handleClosePreFilter()
                            }}
                        />
                    </Box>
                }
                {
                    !preFilter &&
                    <>
                        <TableDataGridV2
                            urlParams
                            columns={colunasRecebimentoBaixas}
                            url="/financeiro/contas-receber/pesquisar-recebimentos-baixas"
                            queryKey="listar-recebimentos-baixas"
                            pagination="server"
                            getLimitAndPage={(limit, page) => { setFilters(prev => ({ ...prev, limit, page: page + 1 })) }}
                        />
                    </>
                }
            </>
        );

        return React.memo(TableComponent);
    }, [preFilter]);

    return (
        <>
            <ScreenBanner title="Financeiro" />
            <PermissionGuard permissionId="financeiro.contas-receber-listar-recebimentos-baixas">

                <Container sx={{ mt: 3 }}>
                    <Typography textAlign="center" variant="h5" mb={2}>Recebimentos e baixas</Typography>

                    <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 3}}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                                fullHeight={false}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 9}} ref={containerRef} >
                            <Box component={Paper}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" px={3} pt={2}>
                                    <Typography variant="h6">Lista de recebimentos</Typography>

                                    {
                                        !preFilter &&
                                        <Stack alignItems="flex-end" justifyContent="center" direction="row" gap={2}>
                                            <IconButton sx={{ p: 0 }} aria-label="delete" onClick={() => {
                                                setFilters(initialFiltersRecebimentoBaixas);
                                                setPreFilter(true)
                                            }}>
                                                <TuneOutlinedIcon />
                                            </IconButton>

                                            <IconButton sx={{ p: 0 }} aria-label="delete" onClick={() => setOpenFullScreen(true)}>
                                                <FullscreenIcon />
                                            </IconButton>
                                        </Stack>
                                    }
                                </Box>

                                {!preFilter && <BtnImprimirRelatorio {...{ filters }} boxProps={{ p: 2 }} />}
                                <RenderListagem />
                            </Box>
                        </Grid>
                    </Grid>
                </Container>

                {
                    openFullScreen &&
                    <DialogListarTodas
                        open={openFullScreen}
                        handleClose={() => setOpenFullScreen(false)}
                        title="Lista de recebimentos    "
                    >
                        <RenderListagem />
                    </DialogListarTodas>
                }

                {
                    openRegistrarDialog &&
                    <DialogRegistrarRecebimento
                        open={openRegistrarDialog}
                        handleClose={() => setOpenRegistrarDialog(false)}
                    />
                }
                {
                    openIncluirDialog &&
                    <DialogIncluirRecebimento
                        open={openIncluirDialog}
                        handleClose={() => setOpenIncluirDialog(false)}
                    />
                }
            </PermissionGuard>
        </>
    )
}

export type TPreFilters = {
    [key: string]: any
}